<template>
    <div>
        <div class="box">
            <img src="./shan.jpg" alt="" class="bgImg" />
            <i class="back iconfont iconfanhui" @click="$router.push('/')" />
            <div class="scan_code" v-show="isWeChat"></div>
            <div v-show="!isWeChat" class="login_box">
                <div class="switch">
                    <p
                        @click="switch_login(0)"
                        :class="switch_login_index == 0 ? 'p_active' : ''"
                    >
                        微信登录
                    </p>
                    <p
                        @click="switch_login(1)"
                        :class="switch_login_index == 1 ? 'p_active' : ''"
                    >
                        账号登录
                    </p>
                </div>
                <div class="account_login">
                    <div v-show="!show_login">
                        <div class="img">
                            <img :src="$store.state.logo" v-if="shop_id" />

                            <img src="../../assets/img/logo.png" alt v-else/>
                        </div>
                        <div class="login">
                            <div class="username inputWrap">
                                <label>
                                    <i class="iconfont iconshouji" />
                                </label>
                                <van-field
                                    :value="loginInfo.mobile"
                                    @focus="focusMobile"
                                    placeholder="请输入店员手机号"
                                    class="input"
                                />
                            </div>
                            <!-- <div class="password inputWrap">
            <label>
              <i class="iconfont iconmima" />
            </label>
            <input v-model="loginInfo.captcha" placeholder="请输入图形验证码" />
        
            <div style="position:relative">
              <img class="gain" :src="codeImg" @click="getcaptcha()" />
            </div>
          </div> -->
                            <!-- 验证码 -->
                            <div class="password inputWrap">
                                <label>
                                    <i class="iconfont iconyanzhengma" />
                                </label>
                                <van-field
                                    class="input"
                                    :value="loginInfo.password"
                                    @focus="focusPassword"
                                    placeholder="请输入密码"
                                />
                                <!-- 获取验证码 -->
                                <!-- <div class="btnWrap">
              <button class="getCode" @click="sendMessage" v-show="show">获取验证码</button>
              <div class="getCode" v-show="!show">{{timers}}</div>
            </div> -->
                            </div>
                            <!-- 登录按钮 -->
                            <button class="login_btn" @click="login">
                                登录
                            </button>
                        </div>
                    </div>
                </div>
                <div v-show="show_login">
                    <div id="login-iframe"></div>
                </div>
            </div>
        </div>
        <van-number-keyboard
            title="输入手机号码"
            @input="onInput"
            @delete="deleteMobile"
            close-button-text="关闭"
            maxlength="11"
            :show="showMobileKey"
            @close="showMobileKey = false"
        />
        <van-number-keyboard
            title="输入密码"
            @input="onInputPassword"
            @delete="deletePassword"
            close-button-text="关闭"
            :show="showPasswordKey"
            @close="showPasswordKey = false"
        />
    </div>
</template>
<script
  type="text/javascript"
  src="http://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js"
></script>
<script>
import { captcha, code, login_mobile, getWxLoginUrl } from "../../api/http.js";
import { getLocalStorage } from "@/utils/storage.js";
import wxlogin from "vue-wxlogin";
import $ from "jquery";
export default {
    data() {
        return {
            loginInfo: {
                mobile: "",
                password: "",
            },
            values: "获取验证码",
            timers: null,
            timer: 6,
            show: true,
            codeImg: "",
            showMobileKey: false,
            showPasswordKey: false,
            Mobile: null,
            wxlogin: {},
            isWeChat: false,
            timer: null,
            switch_login_index: 1,
            show_login: false,
            href: null,
            shop_id: getLocalStorage("shop_id"),
        };
    },
    components: {
        wxlogin,
    },
    created() {},
    mounted() {

        if(process.env.VUE_APP_ISAPP=='true'){
            document.getElementsByClassName("login_box")[0].style.display = 'none'
            window.electronAPI.showWeiXinLogin()
        }else{
            const s = document.createElement("script");
            s.type = "text/javascript";
            s.src = "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js";
            const wxElement = document.body.appendChild(s);
            this.isMobile();
            if (this.Mobile) {
            }
            this.getWxCode();
            this.timer = setInterval(() => {
                this.getWxCode();
            }, 60000);

            setTimeout(()=>{
                this.getWxCode();
            },600)
        }
        
    },
    destroyed() {
        clearInterval(this.timer);
    },
    methods: {
        switch_login(num) {
            this.switch_login_index = num;
            if (this.switch_login_index == 1) {
                this.show_login = false;
                this.getWxCode();
            } else {
                this.show_login = true;
            }
        },
        getWxCode() {
            getWxLoginUrl().then((res) => {
                if (this.Mobile) {
                    this.href =
                        "LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDE4MHB4O30KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge3dpZHRoOiAxODBweDt9Ci5pbXBvd2VyQm94IC5pbmZvIHAge2ZvbnQtc2l6ZToxMHB4O30KLnN0YXR1c19pY29uIHtkaXNwbGF5OiBub25lfQouaW1wb3dlckJveCAuc3RhdHVzX2ZhaWwsLmltcG93ZXJCb3ggLnN0YXR1c19zdWNje3dpZHRoOjIwMHB4O3BhZGRpbmc6MDt9Ci5pbXBvd2VyQm94IC5zdGF0dXMge3RleHQtYWxpZ246IGNlbnRlcjt9";
                } else {
                    $("#login-iframe").css({
                        marginTop: "30px",
                    });
                    this.href =
                        "LmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8gcCB7Zm9udC1zaXplOjEwcHg7fQouc3RhdHVzX2ljb24ge2Rpc3BsYXk6IG5vbmV9Ci5zdGF0dXNfc3VjYywuc3RhdHVzX2ZhaWx7aGVpZ2h0OjIwMHB4fQouaW1wb3dlckJveCAuaWNvbjM4X21zZ3tkaXNwbGF5OmJsb2NrO21hcmdpbjowIGF1dG87fQouaW1wb3dlckJveCAuc3RhdHVzIHt0ZXh0LWFsaWduOiBjZW50ZXI7fQ==";
                }
                let path = encodeURIComponent(
                    window.location.origin + "/wechat"
                );
                // let path = encodeURIComponent(
                //   "https://pad.shanheji.com.cn/index.php?s=/api/user/pcLogin&wxapp_id=10013"
                // );
                var obj = new WxLogin({
                    id: "login-iframe", // 需要显示的容器id
                    appid: res.data.appid, // 公众号appid wx*******
                    scope: "snsapi_login", // 网页默认即可
                    redirect_uri: path, // 授权成功后回调的url
                    state: res.data.state, // 可设置为简单的随机数加session用来校验
                    style: "black", // 提供"black"、"white"可选。二维码的样式
                    href: "data:text/css;base64," + this.href,
                });
            });
        },
        // weChatlogin() {
        //   this.isWeChat = !this.isWeChat;
        //   if (!this.isWeChat) {
        //     this.getWxCode();
        //   }
        // },
        isMobile() {
            if (screen.height == 1080 && screen.width == 1920) {
                return (this.Mobile = false); // PC端
            } else {
                return (this.Mobile = true); //移动端
            }
        },
        timekeeping() {
            //倒计时
            let auth_timer = setInterval(() => {
                //定时器设置每秒递减
                this.timer--; //递减时间
                this.show = false;
                if (this.timer > 0) {
                    this.Verification = true; //60s时间结束还原v-show状态并清除定时器
                    const tim = this.timer;
                    // this.values=tim+"秒后获取"
                    this.timers = tim + "秒后获取";
                } else if (this.timer == 0) {
                    clearInterval(auth_timer);
                    this.show = true;
                    this.timer = 60;
                }
            }, 1000);
        },
        sendMessage() {
            //获取验证码
            if (
                !/^1((3|5|8){1}\d{1}|70|99)\d{8}$/.test(this.loginInfo.usename)
            ) {
                this.$toast.fail("手机号错误");
                return;
            }
            if (this.loginInfo.captcha == "") {
                this.$toast.fail("请正确填写图形验证码");
                return;
            }
            this.timekeeping();
            this.getcode();
            // this.mylogin()
        },
        getcaptcha() {
            captcha(20, 50, 101, 3).then((res) => {
                // page sortType  sortPrice  category_id  search  wxapp_id
                this.loginInfo.captcha_id = res.data.id;
                this.codeImg = res.data.captcha;
            });
        },
        getcode() {
            code(
                this.loginInfo.usename,
                this.loginInfo.captcha_id,
                this.loginInfo.captcha
            ).then((res) => {
                //page sortType  sortPrice  category_id  search  wxapp_id
                if (res.code == 0) {
                    this.$toast.fail("验证码获取失败");
                } else if (res.code == 10500) {
                    this.$toast.fail("图形验证码错误");
                }
            });
        },
        login() {
            //   if (!/^1((3|5|8){1}\d{1}|70|99)\d{8}$/.test(this.loginInfo.usename)) {
            //     this.$toast.fail("手机号错误");
            //     return;
            //   }
            let shop_id = getLocalStorage("shop_id");

            login_mobile(
                this.loginInfo.mobile,
                this.loginInfo.password,
                shop_id
            ).then((res) => {
                if (res.code == 1) {
                    localStorage.setItem("login_token", res.data.token);
                    localStorage.setItem("user_type", res.data.user_type);
                    this.$router.replace("/");
                } else if (res.code == 0) {
                    this.$toast.fail(res.msg);
                }
            });
        },
        msg() {
            this.$toast("暂未开通此接口");
        },

        focusMobile() {
            document.activeElement.blur();
            this.showPasswordKey = false;
            this.showMobileKey = true;
        },
        deleteMobile() {
            if (this.loginInfo.mobile) {
                let mobile = this.loginInfo.mobile.slice(
                    0,
                    this.loginInfo.mobile.length - 1
                );
                this.loginInfo.mobile = mobile;
            }
        },
        onInput(key) {
            if (this.loginInfo.mobile.length > 10) {
                return;
            }
            let keys = String(key);
            this.loginInfo.mobile = this.loginInfo.mobile.concat(keys);
        },

        onInputPassword(key) {
            let keys = String(key);
            this.loginInfo.password = this.loginInfo.password.concat(keys);
        },

        deletePassword() {
            if (this.loginInfo.password) {
                let password = this.loginInfo.password.slice(
                    0,
                    this.loginInfo.password.length - 1
                );
                this.loginInfo.password = password;
            }
        },
        focusPassword() {
            document.activeElement.blur();
            this.showMobileKey = false;
            this.showPasswordKey = true;
        },
    },
};
</script>
<style lang="scss" scoped>
#login-iframe {
    display: flex;
    justify-content: center;
}
.van-button {
    background: white;
    color: #5a5a5a;
    display: block;
    margin: 20px auto 0;
    border: 0;
}
.wxlogin {
    background: red;
    iframe {
        width: 100px;
    }
}
.box {
    display: flex;
    height: 100vh;
    position: relative;
    .bgImg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        object-fit: cover;
    }
    .back {
        position: fixed;
        top: 0px;
        left: 0px;
        height: 60px;
        width: 60px;
        text-align: center;
        line-height: 60px;
        font-size: 24px;
        z-index: 3;
        color: #fff;
    }
    .scan_code {
        text-align: center;
        width: 190px;
        padding-top: 20px;
        height: 225px;
        background: white;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .old-template {
        width: 200px;
    }
    .login_box {
        width: 363px;
        height: 350px;
        // height:384px;
        background: rgba(255, 255, 255, 1);
        // background: pink;
        box-shadow: -9px 11px 24px 3px rgba(100, 100, 100, 0.14);
        border-radius: 6px;
        position: absolute;
        top: 20%;
        // transform: translateY(-50%);
        right: 90px;
        .switch {
            display: flex;
            justify-content: center;
            margin-top: 20px;
            p {
                margin: 0 30px;
                font-size: 18px;
                padding-bottom: 3px;
            }
            .p_active {
                border-bottom: 4px solid #c9a864;
            }
        }
        .account_login {
            width: 100%;
            position: absolute;
            top: 80px;
            .img {
                height: 43px;
                margin-bottom: 28px;
                text-align: center;
                img {
                    width: 130px;
                }
            }
            .login {
                width: 320px;
                margin: auto;
                .inputWrap {
                    display: flex;
                    height: 45px;
                    margin-bottom: 15px;
                    .input {
                        border: 0px;
                        border-bottom: 1px solid #dcdcdc;
                        border-radius: 0px;
                        font-size: 12px;
                        height: 44px;
                        line-height: 44px;
                        padding: 0px 5px;
                    }
                    label {
                        display: block;
                        height: 44px;
                        width: 45px;
                        line-height: 44px;
                        text-align: center;
                        color: #dcdcdc;
                    }
                }
                .username {
                    .input {
                        width: 275px;
                    }
                }
                .password {
                    input {
                        width: 275px;
                    }
                    .gain {
                        width: 100px;
                        height: 31px;
                        padding: 6.5px 0px;
                        border-bottom: 1px solid #dcdcdc;
                    }
                    .btnWrap {
                        border-bottom: 1px solid #dcdcdc;
                        height: 44px;
                        .getCode {
                            width: 100px;
                            font-size: 12px;
                            border-radius: 15px;
                            height: 30px;
                            border: 0px;
                            background: #c9a864;
                            color: #fff;
                            text-align: center;
                            line-height: 30px;
                        }
                    }
                }
                .login_btn {
                    height: 42px;
                    width: 100%;
                    background: #c9a864;
                    border: 0px;
                    color: #fff;
                    font-size: 12px;
                    border-radius: 21px;
                }
            }
        }
        .wxloginbtn {
            display: block;
            margin: 0 auto;
        }
    }
}
</style>
